import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Background",
  src: "/minecraft/background.webp",
  class: "hide"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Background",
  src: "/modded/background.webp",
  class: "hide"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Background",
  src: "/paladium/background.webp",
  class: "hide"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Background",
  src: "/palanarchy/background.webp",
  class: "hide"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorModal = _resolveComponent("ErrorModal")!
  const _component_Notification = _resolveComponent("Notification")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createVNode(_Transition, {
      name: "app-fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.layout), { key: _ctx.layout }))
      ]),
      _: 1
    }),
    (_ctx.ui.errorModal.isOpen)
      ? (_openBlock(), _createBlock(_component_ErrorModal, {
          key: 0,
          title: _ctx.ui.errorModal.title,
          "primary-action": _ctx.ui.errorModal.primaryButton,
          "secondary-action": _ctx.ui.errorModal.secondaryButton,
          critical: _ctx.ui.errorModal.critical,
          messages: _ctx.ui.errorModal.messages,
          onDidRequestPrimaryAction: _ctx.onPrimaryAction,
          onDidRequestSecondaryAction: _ctx.onSecondaryAction
        }, null, 8, ["title", "primary-action", "secondary-action", "critical", "messages", "onDidRequestPrimaryAction", "onDidRequestSecondaryAction"]))
      : _createCommentVNode("", true),
    (_ctx.ui.error)
      ? (_openBlock(), _createBlock(_component_Notification, _mergeProps({
          key: 1,
          onRequestDismiss: _ctx.dismissError
        }, {state: 'error'}), {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.ui.error), 1)
          ]),
          _: 1
        }, 16, ["onRequestDismiss"]))
      : _createCommentVNode("", true)
  ]))
}